export const languages = [
  { code: 'et', label: 'ee' },
  { code: 'en', label: 'en' },
  { code: 'fi', label: 'fi' },
];

export const defaultLanguage = 'en';
